'use client';


import { Box } from '@mui/material';
import { MenuContainer } from './ui/MenuContainer';
import { RedirectHome } from './ui/RedirectHome';
import { ExitApp } from './components/ExitApp';
import { getSidebarItemsForRole } from './utils';
import { useMemo } from 'react';
import { authStore } from '@/shared/store/authStore/authStore';


export function Sidebar() {
 
  const role = useMemo(() => authStore.state.userInfo?.roleId, [authStore.state.userInfo?.roleId]);
  const filteredItems = getSidebarItemsForRole(role);

  return (
    <Box
      width={'100%'}
      height="100%"
      display="flex"
      justifyContent="space-between"
      flexDirection="column"
    >
      <Box display="flex" flexDirection="column" width="100%" gap={'8px'}>
        <RedirectHome />
        {filteredItems.map((props, index) => {
          return (
            <MenuContainer
              key={index}
              {...props}
            />
          );
        })}
      </Box>
      <ExitApp />
    </Box>
  );
}
